// 3rd party libs
import React from 'react';
import cs from 'classnames';

// local imports
import ShareIcon from '../../../assets/icons/moveButton.svg';
import styles from './ShareButton.module.scss';

type TShareButton = {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
};
const MoveButton: React.FC<TShareButton> = ({ onClick, className, disabled }) => {
  if (disabled) {
    return <img className={cs(styles.btn, className, styles.disabled)} src={ShareIcon} alt="disabled share button" />;
  }

  return <img onClick={onClick} className={cs(styles.btn, className)} src={ShareIcon} alt="share button" />;
};

export default MoveButton;
